import { render } from "./SafeHtml.vue?vue&type=template&id=663ee3a1"
import script from "./SafeHtml.vue?vue&type=script&lang=js"
export * from "./SafeHtml.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__